import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'eview-post-header-nav',
  templateUrl: 'post-header-nav.component.html',
  styleUrls: ['post-header-nav.component.scss']
})
export class PostHeaderNav implements OnInit, OnChanges {
  @Input() public navData;
  @Input() description;
  @Input() showSwithButtons: Boolean;
  @Input() public showSearchBar: Boolean;
  @Input() public viewOnlyMode: Boolean;
  @Input() viewData;
  /** Map rail: format tabs (formId). */
  primaryViewTabs: any[] = [];
  /** When set, tabs with `formId` use this to mark active state (map switches format on same URL). */
  @Input() activeFormId: number | null = null;
  /** Hide the top tab row (e.g. map: formats already shown in switch-buttons). */
  @Input() hideTopNavTabs = false;
  @Output() public onNavClick: EventEmitter<any> = new EventEmitter();
  @Output() public onViewClick: EventEmitter<any> = new EventEmitter();
  @Output() public onSearchClick: EventEmitter<any> = new EventEmitter();
  searchText: string = '';
  activeTabIndex: number = 0;
  /** Map left rail: hide format / list links behind a compact toggle. */
  railPanelCollapsed = false;
  private readonly railCollapsedStorageKey = 'mace.mapFormatRailCollapsed';

  constructor(
    private router: Router) {
  }

  ngOnInit() {
    this.restoreRailPanelCollapsed();
    this.syncViewDataActive();
    this.setActiveTabFromUrl();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['navData'] && this.navData) {
      this.setActiveTabFromUrl();
    }
    if (
      changes['viewData'] ||
      changes['activeFormId'] ||
      changes['hideTopNavTabs']
    ) {
      this.syncViewDataActive();
    }
  }

  private syncViewDataActive() {
    if (!this.viewData) {
      this.primaryViewTabs = [];
      return;
    }
    const url = this.router.url;
    const mapped = this.viewData.map((data: any) => ({
      ...data,
      isActive: this.isViewTabActive(data, url)
    }));
    this.viewData = mapped;
    this.applyViewTabPartition(mapped);
  }

  private applyViewTabPartition(mapped: any[]) {
    const hasFormatTabs = mapped.some(t => t.formId != null);
    if (this.hideTopNavTabs && hasFormatTabs) {
      this.primaryViewTabs = mapped.filter(
        t =>
          t.formId != null &&
          t.viewTabRole !== 'dataListLink' &&
          !(
            t.route && String(t.route).indexOf('/posts') >= 0 && t.formId == null
          )
      );
    } else {
      this.primaryViewTabs = mapped;
    }
  }

  private isViewTabActive(data: any, url: string): boolean {
    const routes: string[] = Array.isArray(data.activeForRoutes)
      ? data.activeForRoutes
      : [];
    const urlMatches = routes.some(r => url.indexOf(String(r || '').split('?')[0]) >= 0);
    if (data.formId != null && this.activeFormId != null) {
      return Number(data.formId) === Number(this.activeFormId) && urlMatches;
    }
    return routes.includes(url);
  }

  private setActiveTabFromUrl() {
    if (this.navData) {
      const currentIndex = this.navData.findIndex(tab => this.router.url.includes(tab.route));
      this.activeTabIndex = currentIndex >= 0 ? currentIndex : 0;
    }
  }

  onSearch() {
    this.onSearchClick.emit(this.searchText)
  }

  setActiveTab(index: number, route: any) {
    this.activeTabIndex = index;
    this.onNavClick.emit(route);
  }

  toggleRailPanel(): void {
    this.railPanelCollapsed = !this.railPanelCollapsed;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(
        this.railCollapsedStorageKey,
        this.railPanelCollapsed ? '1' : '0'
      );
    }
  }

  private restoreRailPanelCollapsed(): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    this.railPanelCollapsed =
      localStorage.getItem(this.railCollapsedStorageKey) === '1';
  }

  validarField(event: KeyboardEvent) {
		const char = event.key;
		
		// Permitir Enter para buscar
		if (char === 'Enter') {
			this.onSearch();
			return;
		}
		
		// Prevenir espacio al inicio o cuando todo está seleccionado
		const input = event.target as HTMLInputElement;
		if (char === ' ' && (this.searchText.length === 0 || input.selectionStart === 0 && input.selectionEnd === this.searchText.length)) {
			event.preventDefault();
			return;
		}
		
		const regex = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s\-_]$/;
		if (!regex.test(char)) {
			event.preventDefault();
		}
	} 
}
